/* Maison Lumina v12 : retour visuel d'ajout au panier.
   - le bouton principal (et le bouton collant) passe en « Ajouté au panier » pendant 1,6 s
   - l'image qui vole vers le panier et l'ouverture du tiroir restent gérées par dolce-v6.js (un seul effet)
   - le message texte « … ajouté au panier » n'est plus affiché (les messages d'erreur restent) */
(function () {
  "use strict";
  var last = null;
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest("[data-quick-add], #addCartBtn, #stickyAdd") : null;
    if (t) last = t;
  }, true);
  var form = document.getElementById("productForm");
  if (form) form.addEventListener("submit", function () { if (!last) last = document.getElementById("addCartBtn"); }, true);

  /* message texte masqué pour les ajouts réussis */
  var toast = document.getElementById("toast");
  if (toast && "MutationObserver" in window) {
    new MutationObserver(function () {
      if (toast.classList.contains("show") && /ajout[ée] au panier/i.test(toast.textContent)) toast.classList.remove("show");
    }).observe(toast, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  }

  function added(btn) {
    if (!btn || (btn.id !== "addCartBtn" && btn.id !== "stickyAdd")) return;
    btn.classList.add("ml-added");
    clearTimeout(btn._mlT);
    btn._mlT = setTimeout(function () { btn.classList.remove("ml-added"); }, 1600);
  }

  var f = window.fetch;
  if (typeof f === "function") {
    window.fetch = function (input) {
      var url = "";
      try { url = typeof input === "string" ? input : (input && input.url) || ""; } catch (e) {}
      var res = f.apply(this, arguments);
      if (url.indexOf("/cart/add") === -1) return res;
      var btn = last;
      return res.then(function (r) {
        if (r.ok) requestAnimationFrame(function () { added(btn); });
        return r;
      });
    };
  }

})();
